/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  // Override to avoid trailing slash when updating account root
  update(_id, data) {
    return axios.patch(this.baseUrl(), data);
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  searchForClasses(companyDocument, academicLevel, year) {
    return axios.get(`${this.baseUrl()}/search_for_classes`, {params: {company_document: companyDocument, academic_level: academicLevel, year: year}});
  }

  syncMaturityOptions() {
    return axios.post(`${this.baseUrl()}/sync_maturity_options`);
  }
}

export default new AccountAPI();
